import { render, staticRenderFns } from "./AccidentStatisticsIndex.vue?vue&type=template&id=ea9ff7ae&scoped=true&"
import script from "./AccidentStatisticsIndex.vue?vue&type=script&lang=js&"
export * from "./AccidentStatisticsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea9ff7ae",
  null
  
)

export default component.exports